var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleAds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.735633 20.2576L11.3596 2.54395C12.7091 3.31772 19.5141 6.98548 20.6131 7.68304L9.98913 25.3977C8.82726 26.8926 -0.736367 22.5262 0.735633 20.2566V20.2576Z",
    fill: "#FBBC04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2606 20.2576L20.6366 2.54507C19.1513 0.137801 15.9526 -0.737016 13.3252 0.684775C10.6978 2.10657 9.89784 5.16928 11.3831 7.68404L22.0071 25.3988C23.4923 27.805 26.6912 28.6797 29.3186 27.258C31.8311 25.8361 32.7458 22.6648 31.2606 20.2597V20.2576Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 27.9422C8.27833 27.9422 10.666 25.6746 10.666 22.8773C10.666 20.0801 8.27833 17.8125 5.333 17.8125C2.38767 17.8125 0 20.0801 0 22.8773C0 25.6746 2.38767 27.9422 5.333 27.9422Z",
    fill: "#34A853"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAds);
export default __webpack_public_path__ + "static/media/google_ads.8fae42304be5c592e8094e8abb988cef.svg";
export { ForwardRef as ReactComponent };